import _, { map } from 'underscore';

( function( $ ) {

	$( document ).ready( function() {

		$( '.more-info' ).on( 'click', function() {
			$( this ).toggleClass( '-active' );
		} )

		// 

		var $pages = $( '.u-profile__page' ),
			$nav = $( '.js-profile-nav' );

			$nav.on( 'click', function() {

			var target = $( this ).data( 'target' );

			$pages.removeClass( '-active' );
			$nav.removeClass( '-active' );

			$( this ).addClass( '-active' );
			$pages.filter( '.' + target ).addClass( '-active' );

		} );

		$( window ).on( 'load', function() {
			
			setTimeout(() => {
				$( '.footer-message' ).remove();
			}, 1000);

		} );

		$( '.js-filter' ).on( 'change', function( e ) {
			
			var val = $( this ).val(),
				url = $( this ).data( 'url' );

			if( val != '' ) {

				if( url.includes( '?' ) ) {
					url += '&filter=' + val;
				} else {
					url += '?filter=' + val;
				}

			}

			window.location = url;

		} );

		// 

		var $header = $( '.header' );
		
		function nav() {
			if( $( window ).scrollTop() > 10 ) {
				$header.addClass( '-stick' );
			} else {
				$header.removeClass( '-stick' );
			}
		}

		var throttled = _.throttle( nav, 100 );
		$( window ).on( 'scroll', throttled );
		$( window ).on( 'load', nav );


		/**
		 * Header user navigation
		 */
		$( '.js--manual-popup-trigger' ).on( 'click', function(e) {

			$( this ).toggleClass( 'header__manual--open' );
			$( '.js--manual-popup' ).toggleClass( 'navbox--open' );

		});
		
		/**
		 * Header user navigation
		 */
		$( '.js--user-nav-trigger' ).on( 'click', function(e) {

			$( '.js--navigation' ).removeClass( 'navbox--open' );

			$( this ).toggleClass( 'header__user-trigger--open' );
			$( '.js--user-nav' ).toggleClass( 'navbox--open' );

		});

		/**
		 * Header navigation
		 */
		$( '.js--nav-trigger' ).on( 'click', function(e) {

			$( '.js--user-nav' ).removeClass( 'navbox--open' );

			$( this ).toggleClass( 'navigation__trigger--open' );
			$( '.js--navigation' ).toggleClass( 'navbox--open' );

		});

		/**
		 * Animate navigation indicator
		 */
		var current_nav_item = ( $( '.js--nav li.current-menu-item' ).index() >= 0 ) ? $( '.js--nav li.current-menu-item' ).index() : 0;
		$( '.js--nav-indicator' ).css( { 'transform': 'translate3d(0, ' + current_nav_item * 100 + '%, 0)' } );

		$( '.js--nav li a' ).hover( function(){ 

			// Set indicator
			var item		= $(this).parent('li'),
				index		= item.index(),
				transform	= index * 100;

			$( '.js--nav-indicator' ).css( { 'transform': 'translate3d(0, ' + transform + '%, 0)' } );

		}, function(){

			// Reset indicator
			$( '.js--nav-indicator' ).css( { 'transform': 'translate3d(0, ' + current_nav_item * 100 + '%, 0)' } );

		});

	} );

} ) ( jQuery );